import ImplementationTypeHelper from 'bpmn-js-properties-panel/lib/helper/ImplementationTypeHelper'

import { is, getBusinessObject } from 'bpmn-js/lib/util/ModelUtil'

import unMap from './implementation/UnMap'

function getImplementationType(element) {
  return ImplementationTypeHelper.getImplementationType(element)
}

export default function(group, element, bpmnFactory, translate) {
  // module.exports = function (group, element, bpmnFactory, translate) {
  // Only return an entry, if the currently selected
  // element is a start event.

  if (
    is(element, 'bpmn:ServiceTask') &&
    element.businessObject.class === 'com.beezlabs.camundaengine.async.UnMap'
  ) {
    group.entries = group.entries.concat(
      unMap(
        element,
        bpmnFactory,
        {
          getBusinessObject: getBusinessObject,
          getImplementationType: getImplementationType
        },
        translate
      )
    )
  }
}
